<div *ngIf="!isReadOnly; else readOnly" fxLayout="column">

  <div class="coverage-form-title">{{'calculator.coverage' | translate}}</div>

  <!-- Nos suscribimos al observable quotation$ para ver si ha cotizado -->
  <div *ngIf="quotation$ | async as quotation; else waitingQuotation">
    <div *ngIf="selectedObject$ | async as selectedObject">    
      <div
        *ngFor="let coverage of coverages$ | async" 
        class="coverage-container"
        fxLayout="column" 
        fxLayoutAlign="space-evenly start"
      >
        <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%;">
          <div class="coverage-title">{{coverage.title}}</div>
          <div *ngIf="!coverage.mandatory">
            <mat-slide-toggle color="primary" [checked]="coverage.seleccionada" (change)="verify(coverage, quotation)" style="font-weight: bold;">+{{coverage.price| currency: 0 : '€'}}/año</mat-slide-toggle>
          </div>
        </div>
        <div class="coverage-detail-title" (click)="onSelect(coverage, selectedObject)"> 
          <mat-icon *ngIf="coverage.IsHidden">expand_more</mat-icon>
          <mat-icon *ngIf="!coverage.IsHidden">expand_less</mat-icon>
          {{'calculator.coverageDetails' | translate}} 
        </div>
        <div class="coverage-detail" [hidden]="coverage.IsHidden || !coverage.details.length" *ngFor="let detalle of coverage.details" >
          <mat-icon class="icon" *ngIf="detalle.imagen" [svgIcon]="detalle.imagen"></mat-icon>
          <p [innerHTML]="detalle.descPantallaSeccion"></p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Template para mostrar si se quiere un "esperando cotizacion" o algo parecido -->
<ng-template #waitingQuotation>
  <div fxLayout="column">
    {{ 'calculator.coverage_content.no_quote' | translate }}
  </div>
</ng-template>

<ng-template #readOnly class="readOnly">
      <div fxLayout="column" fxLayoutAlign="start start">

        <div *ngIf="coveragesContract && coveragesContract.length; else coveragesInput">
          <div class="coverage-title-readOnly">{{'calculator.coverage' | translate}}</div>
          <div class="coverage-content-readOnly state" fxLayout="row" fxLayoutAlign="space-between center" *ngFor="let coverage of coveragesContract">
            {{coverage.descripcion}}
            <mat-icon (click)="InfoDialogReadOnly(coverage)">info_outlined</mat-icon>
          </div>
        </div>

        <ng-template #coveragesInput>
          <div class="coverage-with-state-container" *ngIf="coveragesData && coveragesData.length; else coveragesWithState">
            <div class="coverage-content-withState landing" fxLayout="row" fxLayoutAlign="space-between center" *ngFor="let coverage of coveragesData">
              {{coverage.descripcion}}
              <mat-icon (click)="InfoDialogReadOnly(coverage)">info_outlined</mat-icon>
            </div>
          </div>
        </ng-template>

        <ng-template #coveragesWithState>
          <div class="coverage-title-readOnly">{{'calculator.coverage' | translate}}</div>
          <div *ngIf="selectedObject$ | async as selectedObject">
            <div class="coverage-content-readOnly common" *ngFor="let coverage of coverages$ | async">
              <div *ngIf="coverage.seleccionada">
                {{coverage.title}}
                <mat-icon (click)="InfoDialog(coverage, selectedObject)">info_outlined</mat-icon>
              </div>              
            </div>
          </div>
        </ng-template>
      </div>
  
</ng-template>